import React from 'react';
import Spinner from "../loaders/Spinner";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    title: string;
    onClick?: (event?: any) => void;
    className?: string;
    variant?: 'primary' | 'secondary' | 'tertiary' | 'light' | 'dark' | 'border' | 'plain';
    borderTone?: 'default' | 'primary';
    size?: 'small' | 'medium' | 'large' | 'short' | 'long';
    icon?: string | any;
    icon2?: string | any;
    loading?: boolean;
}

function Button({ title, onClick, variant = 'primary', borderTone = 'default', size = 'small', icon, icon2, loading, className, ...restProps }: ButtonProps) {
    const borderToneClasses = variant === 'border' && borderTone === 'primary' ? 'button_rounded border_primary' : '';

    return (
        <button
            className={`relative z-[1] ${variant === 'plain' ? className : `button ${icon ? 'mr-0 ' : ''} button_${variant} text-center min-w-max button_${size} mb-[8px] md:mb-0 ${borderToneClasses} ${className || ''} !text-nowrap`}`}
            onClick={onClick}
            disabled={loading} // Optionally disable the button while loading
            {...restProps}
        >
            {icon && !loading && (
                <img
                    className='button_icon object-contain w-[15px] sm:w-[20px] mr-[4px] sm:mr-[18px] inline-block'
                    src={icon}
                    alt="button_icon"
                />
            )}

            {loading && (
                <span className="inline-block mr-2">
                    <Spinner /> {/* This should be your spinner component */}
                </span>
            )}

            <strong className='inline-block text-nowrap text-xs sm:text-md'>
                {loading ? 'Loading...' : title}
            </strong>

            {icon2 && !loading && (
                typeof icon2 === 'string' ? (
                    <img
                        className='button_icon object-contain w-[35px] sm:w-[15px] ml-[1px] sm:ml-[18px] inline-block'
                        src={icon2}
                        alt="button_icon"
                    />
                ) : (
                    <span className='button_icon2 inline-block ml-4 sm:ml-8'>{icon2}</span>
                )
            )}
        </button>
    );
}

export default Button;
